import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";

export const useSpinnerStore = defineStore('spinner-store', () => {
  const showCount = ref(0);
  const visible = computed(() => { return 0 < showCount.value });
  const text = ref<string>();

  function show(textContent?: string) {
    showCount.value++;
    text.value = textContent ?? text.value;
  }

  function hide() {
    showCount.value--;
    if (showCount.value < 0) {
      showCount.value = 0;
    }
  }

  watch(visible, value => {
    if (!value) {
      text.value = undefined;
    }
  })

  async function showSpinner<T>(action: () => Promise<T>, text?: string): Promise<T> {
    try {
      show(text);
      return await action();
    } finally {
      hide();
    }
  }

  return { visible, text, show, hide, showSpinner }
});
